import { Component } from '@angular/core';

@Component({
  selector: 'app-stepcomponents',
  standalone: false,
  templateUrl: './stepcomponents.component.html',
  styleUrl: './stepcomponents.component.scss'
})
export class StepcomponentsComponent {

}
